/**
 * The colours a project or folder can have, and the one a new project gets. Kept apart from
 * utils/workspaceFolders.ts (which reads and writes folders through the browser's Firebase) so
 * the Claude connector, on the server, gives new projects their colours the same way.
 */

export const FOLDER_COLORS = ['lavender', 'flame', 'mint', 'lemon', 'blush', 'ink'] as const;
export type FolderColor = (typeof FOLDER_COLORS)[number];

/** Deterministic colour for a new project, cycling through the palette by creation order. */
export const nextProjectColor = (existingCount: number): FolderColor =>
    FOLDER_COLORS[existingCount % FOLDER_COLORS.length];
